import { create } from 'zustand';
import api from '@/lib/api';
import type { UserProfile, ApiResponse } from '@/types/onboarding';

interface ProfileState {
 profile: UserProfile | null;
 isLoading: boolean;
 error: string | null;

 fetchProfile: () => Promise<void>;
 updateProfile: (data: Partial<UserProfile>) => Promise<void>;
}

export const useProfileStore = create<ProfileState>((set) => ({
 profile: null,
 isLoading: false,
 error: null,

 fetchProfile: async () => {
  set({ isLoading: true, error: null });
  try {
   const response = await api.get<ApiResponse<{ profile: UserProfile }>>(
    '/onboarding/profile'
   );
   set({ profile: response.data.data.profile, isLoading: false });
  } catch (error: any) {
   set({
    error: error.response?.data?.error?.message || 'Failed to fetch profile',
    isLoading: false,
   });
  }
 },

 updateProfile: async (data) => {
  set({ isLoading: true, error: null });
  try {
   const response = await api.put<ApiResponse<{ profile: UserProfile }>>(
    '/onboarding/profile',
    data
   );
   set({ profile: response.data.data.profile, isLoading: false });
  } catch (error: any) {
   set({
    error: error.response?.data?.error?.message || 'Failed to update profile',
    isLoading: false,
   });
   throw error;
  }
 },
}));
